export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		de: {
			common: {
				close: 'Schließen',
				deepLoading: 'Deep-Loading',
				recalculation: 'Neuberechnung',
				reloadView: 'Ansicht neu laden',
				recalculate: 'Neu berechnen',
				logs: 'Logs',
				autoZoom: 'Auto-Zoom',
				showAlerts: 'Alarme anzeigen',
				deepload: 'Deepload',
				timeframes: {
					day: 'Tag',
					week: 'Woche',
					month: 'Monat',
					year: 'Jahr',
					all: 'Alle',
				},
				actions: 'Aktionen',
				historyChange: 'Historie ändern',
				addComment: 'Kommentar hinzufügen',
				valueLabel: 'Wert',
				noComment: '–',
			},
			annotations: {
				modalTitle: 'Annotationen',
				labels: {
					clicked: 'Geklickt: {timestamp}',
					range: 'Bereich: {range}',
					moduleOnly: 'Annotationen sind derzeit nur für Module verfügbar.',
					noSensors:
						'Diesem Diagramm sind keine sichtbaren Sensoren zugeordnet. Aktiviere mindestens einen Sensor, um Annotationen hinzuzufügen.',
				},
				common: {
					reset: 'Zurücksetzen',
					new: 'Neu',
					add: 'Hinzufügen',
					remove: 'Entfernen',
					sensor: 'Sensor',
					selectSensor: 'Sensor auswählen',
					from: 'Von',
					to: 'Bis',
					value: 'Wert',
					comment: 'Kommentar',
					timestamp: 'Zeitstempel',
					close: 'Schließen',
					save: 'Speichern',
					selectModuleHubHistory: 'Wähle ein Modul und einen Hub, um Verlaufsdaten zu bearbeiten.',
					selectModuleHubComments: 'Wähle ein Modul und einen Hub, um Kommentare zu bearbeiten.',
					valuePlaceholder: 'Wert für dieses Intervall setzen',
					commentPlaceholder: 'Optionale Beschreibung',
					commentDetailsPlaceholder: 'Details für diesen Punkt hinzufügen',
				},
				history: {
					title: 'Historie',
					empty: 'Für diese Sensoren sind keine Verlaufsdaten vorhanden.',
					toastSaved: 'Historie gespeichert.',
					toastMissingContext: 'Modul- oder Hub-Information fehlt.',
					toastError: 'Historie konnte nicht gespeichert werden.',
				},
				comments: {
					title: 'Kommentare',
					empty: 'Für die ausgewählten Sensoren gibt es noch keine Kommentare.',
					toastSaved: 'Kommentare gespeichert.',
					toastMissingContext: 'Modul- oder Hub-Information fehlt.',
					toastError: 'Kommentare konnten nicht gespeichert werden.',
				},
			},
			customGraph: {
				save: 'Speichern',
				addNewGraph: 'Neuen Graph hinzufügen',
				noName: 'Ohne Namen',
				newGraph: 'Neuer Custom Graph',
				invalidEquations: 'Ungültige Gleichungen!',
				list: {
					title: 'Custom-Graph-Liste',
					graph: 'Graph',
					empty: 'Keine Graphen gefunden',
					project: 'Projekt-Graph',
					location: 'Standort-Graph',
					hub: 'Hub-Graph',
					level: 'Ebene',
					status: 'Status',
					statusTooltip: {
						project: 'Projektstatus',
						location: 'Standortstatus',
						hub: 'Hub-Status',
					},
					filterPlaceholder: 'Suche in Namen, Projekten oder Standorten',
				},
				general: 'Allgemein',
				name: 'Name',
				project: 'Projekt',
				whichLocation: 'Welcher Standort',
				allProjects: 'Alle Projekte',
				selectProject: 'Projekt auswählen...',
				location: 'Standort',
				allLocations: 'Alle Standorte',
				selectLocation: 'Standort auswählen...',
				timekeyLabel: 'Zeitintervall (erwartetes Intervall)',
				oldSettingsNotice: '(ALTE EINSTELLUNGEN!)',
				noSelectionHint: 'Keine Auswahl = alle Zeitschritte',
				deepTimekey: 'Deep-Zeitintervall',
				noDeepLoading: 'Kein Deep-Loading',
				alertUsers: {
					label: 'Alert-Empfänger',
					placeholder: 'beispiel{at}revotec.at, weitere{at}mail.at',
					hint: 'E-Mail-Adressen mit Komma oder Zeilenumbruch trennen.',
				},
				alertFlags: {
					show: 'Alert-Flags anzeigen',
					modalTitle: 'Alert-Flags',
					modalTitleNamed: 'Alert-Flags • {name}',
					description: 'Sensoren oder Gleichungen ohne Daten in den letzten 24 Stunden.',
					none: 'Keine fehlenden Daten in den letzten 24 Stunden gefunden.',
					lastSeen: 'Zuletzt gesehen:',
					keyLabel: 'Key:',
					never: 'nie',
					close: 'Schließen',
				},
				deleteSectionTitle: 'Graph löschen',
				deleteGraphTitle: 'Diesen Graph löschen',
				deleteGraphQuestion: 'Soll dieser Graph wirklich gelöscht werden?',
				graphAlreadyExists: 'Graph existiert bereits!',
				graphSaved: 'Graph gespeichert.',
				sensors: {
					title: 'Sensoren',
					noneSelected: 'Keine Sensoren ausgewählt',
					remove: 'Entfernen',
					delete: 'Löschen',
					addSensors: 'Sensoren hinzufügen',
					manage: 'Sensoren verwalten',
					unsavedChanges: 'Nicht gespeicherte Änderungen',
					noChanges: 'Keine Änderungen',
					cancel: 'Abbrechen',
					save: 'Speichern',
					emptySelectionHint: 'Wähle rechts einen Sensor aus, um ihn diesem Graphen hinzuzufügen.',
					duplicateWarning: 'Sensor ist bereits ausgewählt.',
					removeSensor: 'Sensor entfernen',
					filterLabel: 'Sensoren filtern',
					hubLabel: 'HUB',
					projectLabel: 'PRJ',
					locationLabel: 'LOC',
					moduleLabel: 'MODUL',
				},
				equations: {
					title: 'Gleichungen',
					addEquation: 'Gleichung hinzufügen',
					duplicateTitle: 'Diese Gleichung duplizieren',
					duplicateQuestion: 'Gleichung wirklich duplizieren?',
					copy: 'Kopieren',
					deleteTitle: 'Diese Gleichung löschen',
					deleteQuestion: 'Gleichung wirklich löschen?',
					delete: 'Löschen',
					equationLabel: 'Gleichung',
					valid: 'gültig',
					invalid: 'ungültig',
					edit: 'Gleichung bearbeiten',
					moduleChooser: {
						operators: 'Operatoren',
						replacementMode: 'Ersatzmodus',
					},
				},
				equationSettings: {
					title: 'Gleichungs-Einstellungen',
					fromModules: 'aus Modulen',
					offset: 'Offset',
					factor: 'Faktor',
					unit: 'Einheit',
					show: 'Anzeigen',
					color: 'Farbe',
					borderSettings: 'Grenzwerte',
					edit: 'Bearbeiten',
					minMaxBadge: 'min/max',
					ignoreBadge: 'ignorieren',
					alertBadge: 'Alarm',
					warnBadge: 'Warnung',
				},
				equationModal: {
					title: 'Gleichung bearbeiten',
					valid: 'Gleichung gültig',
					invalid: 'Gleichung ungültig',
					reset: 'Zurücksetzen',
					resetQuestion: 'Gleichung wirklich zurücksetzen?',
					resetText: 'Gleichung auf den zuletzt gespeicherten Stand zurücksetzen',
					discardTitle: 'Änderungen verwerfen?',
					discardText: 'Änderungen verwerfen und Editor schließen',
					cancel: 'Abbrechen',
					save: 'Speichern',
					editValue: 'Wert bearbeiten',
					numberErrorDigits: 'Nur Ziffern und "." erlaubt',
					numberErrorDecimals: 'Nur ein Dezimalpunkt erlaubt',
					numberErrorUnsupported: 'Nicht unterstütztes Zeichen',
					update: 'Aktualisieren',
					resetValue: 'Zurücksetzen',
					replace: 'Ersetzen',
					delete: 'Löschen',
				},
				borderSettings: {
					max: 'Max',
					ignore: 'Ignorieren',
					alert: 'Alarm',
					warn: 'Warnung',
					min: 'Min',
					infoMaxMinTitle: 'Max/Min:',
					infoMaxMinText:
						'Werte werden ober- und unterhalb abgeschnitten, nicht für Benachrichtigungen ausgewertet und nicht in den Graphen angezeigt.',
					infoIgnoreTitle: 'Ignore (aber sichtbar):',
					infoIgnoreText:
						'Werte zwischen Ignore und Max/Min werden nicht für Benachrichtigungen ausgewertet, bleiben aber in den Graphen sichtbar. Diese Werte sind für Nutzer nicht relevant, können aber z. B. fürs Debugging sichtbar bleiben.',
					infoAlertWarnTitle: 'Alert/Warn:',
					infoAlertWarnText: 'Werte werden für Alarm- und Warnmeldungen ausgewertet.',
				},
			},
		},
		en: {
			common: {
				close: 'Close',
				deepLoading: 'deep-loading',
				recalculation: 'recalculation',
				reloadView: 'Reload View',
				recalculate: 'Recalculate',
				logs: 'Logs',
				autoZoom: 'Auto Zoom',
				showAlerts: 'Show Alerts',
				deepload: 'Deepload',
				timeframes: {
					day: 'day',
					week: 'week',
					month: 'month',
					year: 'year',
					all: 'all',
				},
				actions: 'Actions',
				historyChange: 'History change',
				addComment: 'Add comment',
				valueLabel: 'Value',
				noComment: '–',
			},
			annotations: {
				modalTitle: 'Annotations',
				labels: {
					clicked: 'Clicked: {timestamp}',
					range: 'Range: {range}',
					moduleOnly: 'Annotations are currently available for modules only.',
					noSensors:
						'No visible sensors belong to this chart. Enable at least one sensor to add annotations.',
				},
				common: {
					reset: 'Reset',
					new: 'New',
					add: 'Add',
					remove: 'Remove',
					sensor: 'Sensor',
					selectSensor: 'Select sensor',
					from: 'From',
					to: 'To',
					value: 'Value',
					comment: 'Comment',
					timestamp: 'Timestamp',
					close: 'Close',
					save: 'Save',
					selectModuleHubHistory: 'Select a module and hub to edit history data.',
					selectModuleHubComments: 'Select a module and hub to edit comments.',
					valuePlaceholder: 'Set value for this interval',
					commentPlaceholder: 'Optional description',
					commentDetailsPlaceholder: 'Add details for this point',
				},
				history: {
					title: 'History',
					empty: 'No history entries recorded for these sensors.',
					toastSaved: 'History changes saved.',
					toastMissingContext: 'Missing module or hub information.',
					toastError: 'Failed to save history changes.',
				},
				comments: {
					title: 'Comments',
					empty: 'No comments for the selected sensors yet.',
					toastSaved: 'Comments saved.',
					toastMissingContext: 'Missing module or hub information.',
					toastError: 'Failed to save comments.',
				},
			},
			customGraph: {
				save: 'Save',
				addNewGraph: 'Add new graph',
				noName: 'No name',
				newGraph: 'New Custom Graph',
				invalidEquations: 'Invalid equations!',
				list: {
					title: 'Custom graphs',
					graph: 'Graph',
					empty: 'No graphs found',
					project: 'Project graph',
					location: 'Location graph',
					hub: 'Hub graph',
					level: 'Level',
					status: 'Status',
					statusTooltip: {
						project: 'Project status',
						location: 'Location status',
						hub: 'Hub status',
					},
					filterPlaceholder: 'Filter by name, project, or location',
				},
				general: 'General',
				name: 'Name',
				project: 'Project',
				whichLocation: 'Which location',
				allProjects: 'All Projects',
				selectProject: 'Select project...',
				location: 'Location',
				allLocations: 'All Locations',
				selectLocation: 'Select location...',
				timekeyLabel: 'Timekey (expected interval)',
				oldSettingsNotice: '(OLD SETTINGS!)',
				noSelectionHint: 'No selection = all timesteps',
				deepTimekey: 'Deep timekey',
				noDeepLoading: 'No deep-loading',
				alertUsers: {
					label: 'Alert recipients',
					placeholder: 'example{at}revotec.at, another{at}mail.com',
					hint: 'Separate email addresses with commas or line breaks.',
				},
				alertFlags: {
					show: 'Show alert flags',
					modalTitle: 'Alert flags',
					modalTitleNamed: 'Alert flags • {name}',
					description: 'Sensors or equations that did not send data in the last 24 hours.',
					none: 'No missing data detected in the last 24 hours.',
					lastSeen: 'Last seen:',
					keyLabel: 'Key:',
					never: 'never',
					close: 'Close',
				},
				deleteSectionTitle: 'Delete graph',
				deleteGraphTitle: 'Delete this graph',
				deleteGraphQuestion: 'Are you sure you want to delete this graph?',
				graphAlreadyExists: 'Graph already exists!',
				graphSaved: 'Graph saved.',
				sensors: {
					title: 'Sensors',
					noneSelected: 'No sensors selected',
					remove: 'Remove',
					delete: 'Delete',
					addSensors: 'Add sensors',
					manage: 'Manage sensors',
					unsavedChanges: 'Unsaved changes',
					noChanges: 'No changes',
					cancel: 'Cancel',
					save: 'Save',
					emptySelectionHint: 'Select a sensor on the right to add it to this graph.',
					duplicateWarning: 'Sensor is already selected.',
					removeSensor: 'Remove sensor',
					filterLabel: 'Filter sensors',
					hubLabel: 'HUB',
					projectLabel: 'PRJ',
					locationLabel: 'LOC',
					moduleLabel: 'MODULE',
				},
				equations: {
					title: 'Equations',
					addEquation: 'Add equation',
					duplicateTitle: 'Duplicate this equation',
					duplicateQuestion: 'Are you sure you want to duplicate this equation?',
					copy: 'Copy',
					deleteTitle: 'Delete this equation',
					deleteQuestion: 'Are you sure you want to delete this equation?',
					delete: 'Delete',
					equationLabel: 'Equation',
					valid: 'valid',
					invalid: 'invalid',
					edit: 'Edit equation',
					moduleChooser: {
						operators: 'Operators',
						replacementMode: 'Replacement mode',
					},
				},
				equationSettings: {
					title: 'Equation settings',
					fromModules: 'from modules',
					offset: 'offset',
					factor: 'factor',
					unit: 'unit',
					show: 'show',
					color: 'color',
					borderSettings: 'Border settings',
					edit: 'Edit',
					minMaxBadge: 'min/max',
					ignoreBadge: 'ignore',
					alertBadge: 'alert',
					warnBadge: 'warn',
				},
				equationModal: {
					title: 'Edit equation',
					valid: 'Equation valid',
					invalid: 'Equation invalid',
					reset: 'Reset',
					resetQuestion: 'Are you sure you want to reset the equation?',
					resetText: 'Reset equation to last saved state',
					discardTitle: 'Discard changes?',
					discardText: 'Discard changes and close editor',
					cancel: 'Cancel',
					save: 'Save',
					editValue: 'Edit value',
					numberErrorDigits: 'Only digits and "." allowed',
					numberErrorDecimals: 'Only one decimal point allowed',
					numberErrorUnsupported: 'Unsupported character',
					update: 'Update',
					resetValue: 'Reset',
					replace: 'Replace',
					delete: 'Delete',
				},
				borderSettings: {
					max: 'Max',
					ignore: 'Ignore',
					alert: 'Alert',
					warn: 'Warn',
					min: 'Min',
					infoMaxMinTitle: 'Max/Min:',
					infoMaxMinText:
						'Values will be cut off above and below, not evaluated for messages, and not shown in the graphs.',
					infoIgnoreTitle: 'Ignore (but visible):',
					infoIgnoreText:
						'Values between ignore and max/min are not evaluated for messages but remain visible in the graphs. Use this for values that are irrelevant to users but helpful for debugging.',
					infoAlertWarnTitle: 'Alert/Warn:',
					infoAlertWarnText: 'Values will be evaluated for alert and warn messages.',
				},
			},
		},
	},
}
